export class ThemeSiteContentResponse {
    labelName: string;
    labelText: string;

    constructor() {}
}

export class SiteContent {
    tutorReportHeader: string;
    placementIdLabel: string;
    tutorReportsBaselineHeader: string;
    tutorReportsProgressReportHeader: string;
    tutorReportsSessionDetailComment: string;
    placementHeaderLabel: string;
    ilpBriefCommentLabel: string;
    addSessionButtonLabel: string;
    learnerPupilLabel: string;
    studentPupilLabel: string;
    tutorReportsGroupHeader: string;
    progressReportText: string;
    progressReportTextNtp: string;
    enableStudentEmailing: string;
    maintenanceBookingRefLabel: string;

    constructor() {
        this.tutorReportHeader = "";
        this.placementIdLabel = "";
        this.tutorReportsBaselineHeader = "";
        this.tutorReportsProgressReportHeader = "";
        this.tutorReportsSessionDetailComment = "";
        this.placementHeaderLabel = "";
        this.ilpBriefCommentLabel = "";
        this.addSessionButtonLabel = "";
        this.learnerPupilLabel = "";
        this.studentPupilLabel = "";
        this.tutorReportsGroupHeader = "";
        this.progressReportText = "";
        this.progressReportTextNtp = "";
        this.enableStudentEmailing = "";
        this.maintenanceBookingRefLabel = "";
    }
}